<div class="classroom-form"
     [class.tablet-portrait]="deviceService.isTablet() && isPortrait"
     [class.tablet-landscape]="deviceService.isTablet() && !isPortrait"
     [class.mobile-portrait]="deviceService.isMobile() && isPortrait"
     [class.mobile-landscape]="deviceService.isMobile() && !isPortrait">

  <h2 class="title bold">
    {{ (isNew ? 'classrooms.form.titles.create' : 'classrooms.form.titles.edit') | translate }}
  </h2>

  <div *ngIf="form" class="form" [formGroup]="form">
    <ng-container *ngIf="false">
      <app-form-field class="classroom-field" label="{{ 'classrooms.steps.students' | translate }}">
        <div class="participants">
          <app-classroom-participants [classroom]="classroom"></app-classroom-participants>
        </div>
      </app-form-field>
    </ng-container>

    <div class="step-3">
      <div class="cover">
        <app-form-field [control]="form.controls.cover_id">
          <app-image-uploader class="control cover_id"
                              [display]="'wide'" [autoCrop]="true"
                              [cropRatio]="'wide'"
                              formControlName="cover_id">
          </app-image-uploader>
        </app-form-field>
      </div>
      <div class="meta">
        <app-form-field class="title-field">
          <on-ui-input class="control title"
                     formControlName="title"
                     [maxlength]="90"
                     [hasCounter]="true"
                     [placeholder]="'meetings.form-title-placeholder' | translate">
          </on-ui-input>
          <ng-template [ngIf]="isInvalid('title')">
            <ng-container *ngTemplateOutlet="warnInput; context:{ message: 'meetings.form-title-warn' | translate }"></ng-container>
          </ng-template>
        </app-form-field>

        <app-form-field>
          <on-ui-textarea class="control description"
                        placeholder="{{ 'meetings.form-description-placeholder' | translate }}"
                        formControlName="description"
                        [maxlength]="2000">
          </on-ui-textarea>
        </app-form-field>

        <div class="access-section">
          <div *ngFor="let type of accessTypes; trackBy: trackByFn" class="access">
            <on-ui-radio formControlName="access"
                         [radio]="type"
                         (changed)="onAccessChange($event)">
            </on-ui-radio>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <on-ui-button class="button primary outline"
                    label="classrooms.form.actions.cancel"
                    (click)="cancel()">
      </on-ui-button>
      <on-ui-button [state]="saveState"
                    class="button primary"
                    [label]="isNew ? 'classrooms.form.actions.create' : 'classrooms.form.actions.save'"
                    (click)="save()">
      </on-ui-button>
    </div>
  </div>
</div>

<ng-template #warnInput let-message="message">
  <div class="warning-input">
    <div class="warn-message normal">{{ message | translate }}</div>
  </div>
</ng-template>
